import { useRef, useEffect } from "react";
import { useTracking } from "@edreamsodigeo/frontend-core";

import { useIsMeta } from "~/clientState/providers/SessionScopeProvider/SessionScopeProvider";
import type { UseTrackingOnloadEventProps } from "~/components/engage/DualPriceStickyBar/contract";

const useTrackingOnloadEvent = ({
  discountedPricePerPassenger,
  nonDiscountedPricePerPassenger,
  isFlightSummary,
  trackingParams,
}: UseTrackingOnloadEventProps): void => {
  const { trackEvent } = useTracking();
  const isTrackingOnloadExecuted = useRef<boolean>(false);
  const isMeta = useIsMeta();

  useEffect(() => {
    if (
      isMeta &&
      !isTrackingOnloadExecuted.current &&
      !!discountedPricePerPassenger &&
      !!nonDiscountedPricePerPassenger &&
      isFlightSummary
    ) {
      isTrackingOnloadExecuted.current = true;
      trackEvent(trackingParams);
    }
  }, [
    isMeta,
    isFlightSummary,
    discountedPricePerPassenger,
    nonDiscountedPricePerPassenger,
    trackEvent,
    trackingParams,
  ]);
};

export default useTrackingOnloadEvent;
